/* ============================================================
   Rype theme JS
   - Hero slider color switcher (per slide background change)
   - Review popup modal
   - Cart updates (Shopify AJAX)
   - Smooth-scroll for anchor links
   ============================================================ */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    // ================================================================
    // 1. Hero slider color switcher
    //    Each slide changes the page bg + CTA color
    // ================================================================
    (function heroSliderColors() {
      var slider = document.querySelector('.main-slider');
      if (!slider) return;

      var zeroSugar = document.querySelector('.firstfoldbadge.zero-sugar');
      var thaiGoodness = document.querySelector('.firstfoldbadge.thai-goodness');
      var coconut = document.querySelector('.firstfoldbadge.coconut');

      var slideVars = [
        { primary: "#fdf2f7", secondary: "#ed1846", image: zeroSugar },
        { primary: "#fffadc", secondary: "#f7941d", image: zeroSugar },
        { primary: "#eaf0bb", secondary: "#8b9b3a", image: zeroSugar },
        { primary: "#fffde5", secondary: "#fdb714", image: zeroSugar },
        { primary: "#e7f6fd", secondary: "#0f90c0", image: coconut },
        { primary: "#f8eff5", secondary: "#a466aa", image: thaiGoodness }
      ];

      function tryInit() {
        var ariaLabel = slider.querySelector('.w-slider-aria-label');
        if (!ariaLabel) {
          setTimeout(tryInit, 300);
          return;
        }
        function updateFromLabel() {
          var text = ariaLabel.textContent || '';
          var match = text.match(/Slide\s+(\d+)/i);
          if (!match) return;
          var index = parseInt(match[1], 10) - 1;
          var vars = slideVars[index];
          if (!vars) return;
          var root = document.documentElement;
          root.style.setProperty('--primary-background-clr', vars.primary);
          root.style.setProperty('--primary-cta-clr', vars.secondary);
          if (zeroSugar) zeroSugar.style.display = 'none';
          if (thaiGoodness) thaiGoodness.style.display = 'none';
          if (coconut) coconut.style.display = 'none';
          if (vars.image) vars.image.style.display = 'inline-block';
        }
        updateFromLabel();
        var observer = new MutationObserver(updateFromLabel);
        observer.observe(ariaLabel, { childList: true, subtree: true });
      }
      tryInit();
    })();

    // ================================================================
    // 2. Review popup modal
    //    Open/close + star rating + submission are handled by the
    //    inline scripts inside the popup section (preserves original
    //    Webflow + HubSpot integration). We only add an outside-click
    //    close as a UX nicety since the inline script doesn't include it.
    // ================================================================
    (function reviewPopupOutsideClick() {
      var popup = document.getElementById('pop-up');
      if (!popup) return;
      popup.addEventListener('click', function (e) {
        if (e.target === popup) popup.style.display = 'none';
      });
    })();

    // ================================================================
    // 4. Smooth scroll for anchor links
    //    Handles cases like /#process from any page
    // ================================================================
    (function smoothScroll() {
      // If we land on the page with a hash, scroll on load
      if (window.location.hash) {
        setTimeout(function () {
          var target = document.querySelector(window.location.hash);
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 200);
      }

      document.addEventListener('click', function (e) {
        var link = e.target.closest('a');
        if (!link) return;
        var href = link.getAttribute('href');
        if (!href) return;

        // Same-page anchor
        if (href.indexOf('#') === 0 && href.length > 1) {
          var target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            history.pushState(null, '', href);
          }
        }
        // Cross-page anchor: e.g. /#process when on /products/...
        else if (href.indexOf('/#') === 0) {
          // If we're on home, treat as anchor; otherwise let it navigate
          if (window.location.pathname === '/' || window.location.pathname === '') {
            var t2 = document.querySelector('#' + href.split('#')[1]);
            if (t2) {
              e.preventDefault();
              t2.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        }
      });
    })();

    // ================================================================
    // 5. Cart count badge updater
    // ================================================================
    function refreshCartCount() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? '' : 'none';
          });
        }).catch(function () {});
    }
    refreshCartCount();

    // ================================================================
    // 6. Cart toast notification
    // ================================================================
    function showToast(msg, isError) {
      var t = document.createElement('div');
      t.className = 'cart-toast';
      if (isError) t.style.background = '#c33';
      t.textContent = msg;
      document.body.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('is-visible'); });
      setTimeout(function () {
        t.classList.remove('is-visible');
        setTimeout(function () { t.remove(); }, 300);
      }, 2400);
    }

    // ================================================================
    // 7. Add-to-cart form intercept
    // ================================================================
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector('button[type="submit"], input[type="submit"]');
      var originalText = btn ? (btn.textContent || btn.value) : '';
      if (btn) {
        btn.disabled = true;
        if (btn.tagName === 'INPUT') btn.value = 'Adding...'; else btn.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      })
      .then(function () {
        showToast('Added to cart');
        refreshCartCount();
        if (btn) {
          btn.disabled = false;
          if (btn.tagName === 'INPUT') btn.value = originalText; else btn.textContent = originalText;
        }
      })
      .catch(function (err) {
        showToast(err && err.description ? err.description : 'Could not add to cart', true);
        if (btn) {
          btn.disabled = false;
          if (btn.tagName === 'INPUT') btn.value = originalText; else btn.textContent = originalText;
        }
      });
    });

    // ================================================================
    // 8. Variant picker (product page)
    // ================================================================
    (function variantPicker() {
      var picker = document.querySelector('[data-variant-picker]');
      var productJsonEl = document.getElementById('product-json');
      if (!picker || !productJsonEl) return;
      var product = JSON.parse(productJsonEl.textContent);
      var variantInput = document.querySelector('input[name="id"]');
      var priceEl = document.querySelector('[data-product-price]');
      var compareEl = document.querySelector('[data-product-compare]');
      var btn = document.querySelector('[data-add-to-cart]');

      function findVariant() {
        var selects = picker.querySelectorAll('select');
        var chosen = [];
        selects.forEach(function (s) { chosen.push(s.value); });
        return product.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === chosen[i]; });
        });
      }
      function fmt(cents) {
        return (cents / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD'
        });
      }
      function update() {
        var v = findVariant();
        if (!v) return;
        if (variantInput) variantInput.value = v.id;
        if (priceEl) priceEl.textContent = fmt(v.price);
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = fmt(v.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (btn) {
          if (v.available) {
            btn.disabled = false;
            if (btn.tagName === 'INPUT') btn.value = 'Add to cart'; else btn.textContent = 'Add to cart';
          } else {
            btn.disabled = true;
            if (btn.tagName === 'INPUT') btn.value = 'Sold out'; else btn.textContent = 'Sold out';
          }
        }
      }
      picker.addEventListener('change', update);
    })();

    // ================================================================
    // 9. Cart page quantity update
    // ================================================================
    document.addEventListener('change', function (e) {
      if (!e.target.matches('.cart-qty-input')) return;
      var line = e.target.getAttribute('data-line');
      var qty = parseInt(e.target.value, 10) || 0;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); });
    });

    // ================================================================
    // 10. Quantity stepper (+/-) on homepage product cards
    // ================================================================
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.rype-qty-btn');
      if (!btn) return;
      e.preventDefault();
      var stepper = btn.closest('.rype-qty-stepper');
      if (!stepper) return;
      var input = stepper.querySelector('.rype-qty-input');
      if (!input) return;
      var current = parseInt(input.value, 10) || 1;
      var action = btn.getAttribute('data-qty-action');
      if (action === 'inc') {
        input.value = current + 1;
      } else if (action === 'dec') {
        input.value = Math.max(1, current - 1);
      }
    });

  });
})();
